module.exports = __webpack_public_path__ + "images/5a12be2d4805755cecc3828f10e55d7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/intro-main02.jpg
// module id = ./webpack/assets/img/intro-main02.jpg
// module chunks = 0